import styled from "styled-components";
export const InfoMessageContainer = styled.div `
  border-radius: 0.75rem;
  border: 1px solid #E3E3E3;
  box-sizing: border-box;
`;
